import { render } from "./RegistrationList.vue?vue&type=template&id=a0df57dc"
import script from "./RegistrationList.vue?vue&type=script&lang=js"
export * from "./RegistrationList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__